import { useEffect, type RefObject } from 'react';
import type { AccountPoints } from './useAccountPoints';

export function useHistoryAutoload(
  open: boolean,
  sentinel: RefObject<HTMLElement | null>,
  account?: AccountPoints,
) {
  const cursor = account?.data?.history.nextCursor;
  const busy = account?.busy;
  const error = account?.historyError;
  const loadMore = account?.loadMore;
  // React can batch a quick refresh's busy=true/false into one render.
  // Recheck the sentinel after every completion, including failed refreshes.
  const requestVersion = account?.requestVersion;
  useEffect(() => {
    if (!open || !cursor || busy || error || !loadMore || !sentinel.current)
      return;
    let active = true;
    const observer = new IntersectionObserver(
      (entries) => {
        if (active && entries.some((entry) => entry.isIntersecting)) {
          active = false;
          observer.disconnect();
          loadMore();
        }
      },
      { rootMargin: '0px 0px 200px 0px' },
    );
    observer.observe(sentinel.current);
    return () => {
      active = false;
      observer.disconnect();
    };
  }, [open, cursor, busy, error, loadMore, sentinel, requestVersion]);
}
